import {Color} from '@benchling/nucleus-ui';
import {createStyles} from '@mantine/core';

import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';

const MAPPING_MODAL_MIN_WIDTH = 400;

export const useSelectTaskColumnMappingsModalStyles = createStyles((theme) => ({
  columnMappingsSection: {
    minWidth: MAPPING_MODAL_MIN_WIDTH,
  },
  columnMappingsTitle: {
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    fontSize: theme.fontSizes.sm,
    marginBottom: theme.spacing.sm,
  },
  mappingTableHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing.sm,
    gap: theme.spacing.sm,
  },
  mappingHeaderCell: {
    flex: '1 1 0',
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    fontSize: theme.fontSizes.xs,
    lineHeight: theme.fontSizes.sm,
  },
  mappingHeaderRemove: {
    width: 24,
    flex: '0 0 auto',
  },
  mappingTableRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    marginBottom: theme.spacing.xs,
  },
  mappingCellSource: {
    flex: '1 1 0',
    minWidth: 0,
  },
  mappingCellDest: {
    flex: '1 1 0',
    minWidth: 0,
  },
  mappingRowArrow: {
    flex: '0 0 auto',
    color: Color.GRAY_600,
    fontSize: theme.fontSizes.sm,
    lineHeight: 1,
    alignSelf: 'center',
  },
  mappingCellRemove: {
    flex: '0 0 auto',
    width: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  schemaText: {
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    fontSize: theme.fontSizes.sm,
  },
}));
